import React from "react";
import {
  ReportSearchContainer,
  SearchBox,
  SearchIconDiv,
} from "../../style/Table.style";
import SearchIcon from "@mui/icons-material/Search";

const ReportFilter = ({ filter, setFilter }) => {
  return (
    <>
      <ReportSearchContainer>
        <SearchIconDiv style={{ marginTop: "2px", marginLeft: "2px" }}>
          <SearchIcon />
        </SearchIconDiv>
        <SearchBox
          value={filter || ""}
          onChange={(e) => setFilter(e.target.value)}
          placeholder="Search ...."
          maxLength={50}
        />
      </ReportSearchContainer>
    </>
  );
};

export default ReportFilter;
